import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const IRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="IR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          stroke="#F7FCFF"
          strokeWidth={0.5}
          d="M.186 8.684H-.95M-.962 9.134v-.261h.37v.252h.374v-.252h-.194M.17 9.123h-.19v-.245h.397v-.2.445h.18v-.446M.759 8.704v.421H.573M2.138 8.684H1M.989 9.134v-.261h.37v.252h.374v-.252h-.194M2.155 9.123h-.188v-.245h.396v-.2.445h.18v-.446M2.745 8.704v.421H2.56M4.124 8.684H2.987M2.975 9.134v-.261h.37v.252h.374v-.252h-.194M4.106 9.123h-.188v-.245h.397v-.2.445h.18v-.446M4.696 8.704v.421H4.51M6.075 8.684H4.938M4.926 9.134v-.261h.37v.252h.374v-.252h-.194M6.058 9.123h-.189v-.245h.397v-.2.445h.18v-.446M6.648 8.704v.421H6.46M8.026 8.684H6.89M6.877 9.134v-.261h.37v.252h.374v-.252h-.194M8.044 9.123h-.189v-.245h.397v-.2.445h.18v-.446M8.634 8.704v.421h-.187M10.012 8.684H8.875M8.863 9.134v-.261h.37v.252h.375v-.252h-.194M10.03 9.123H9.84v-.245h.397v-.2.445h.18v-.446M10.62 8.704v.421h-.187M11.998 8.684h-1.137M10.85 9.134v-.261h.37v.252h.374v-.252H11.4M12.016 9.123h-.189v-.245h.397v-.2.445h.18v-.446M12.606 8.704v.421h-.187M13.984 8.684h-1.137M12.835 9.134v-.261h.37v.252h.375v-.252h-.194M13.967 9.123h-.188v-.245h.396v-.2.445h.18v-.446M14.557 8.704v.421h-.186M15.935 8.684H14.8M14.787 9.134v-.261h.37v.252h.374v-.252h-.194M16.023 9.123h-.189v-.245h.397v-.2.445h.18v-.446M.186 2.583H-.95M-.962 3.034v-.261h.37v.252h.374v-.252h-.194M.17 3.023h-.19v-.245h.397v-.2.445h.18v-.446M.759 2.604v.42H.573M2.138 2.583H1M.989 3.034v-.261h.37v.252h.374v-.252h-.194M2.155 3.023h-.188v-.245h.396v-.2.445h.18v-.446M2.745 2.604v.42H2.56M4.124 2.583H2.987M2.975 3.034v-.261h.37v.252h.374v-.252h-.194M4.106 3.023h-.188v-.245h.397v-.2.445h.18v-.446M4.696 2.604v.42H4.51M6.075 2.583H4.938M4.926 3.034v-.261h.37v.252h.374v-.252h-.194M6.058 3.023h-.189v-.245h.397v-.2.445h.18v-.446M6.648 2.604v.42H6.46M8.026 2.583H6.89M6.877 3.034v-.261h.37v.252h.374v-.252h-.194M8.044 3.023h-.189v-.245h.397v-.2.445h.18v-.446M8.634 2.604v.42h-.187M10.012 2.583H8.875M8.863 3.034v-.261h.37v.252h.375v-.252h-.194M10.03 3.023H9.84v-.245h.397v-.2.445h.18v-.446M10.62 2.604v.42h-.187M11.998 2.583h-1.137M10.85 3.034v-.261h.37v.252h.374v-.252H11.4M12.016 3.023h-.189v-.245h.397v-.2.445h.18v-.446M12.606 2.604v.42h-.187M13.984 2.583h-1.137M12.835 3.034v-.261h.37v.252h.375v-.252h-.194M13.967 3.023h-.188v-.245h.396v-.2.445h.18v-.446M14.557 2.604v.42h-.186M15.935 2.583H14.8M14.787 3.034v-.261h.37v.252h.374v-.252h-.194M16.023 3.023h-.189v-.245h.397v-.2.445h.18v-.446"
        />
        <Path
          fill="#E31D1C"
          d="M8.268 4.405c.013.014.738.804.692 1.684-.028.53-.437 1.087-.762 1.453.158.035.37.078.662.136.013.068-.289-.013-.84.057a4.914 4.914 0 0 1-.223.215l-.037-.045-.037.045a4.86 4.86 0 0 1-.221-.215c-.552-.07-.854.01-.841-.057.291-.058.503-.1.66-.136-.324-.366-.731-.924-.759-1.453-.046-.882.683-1.674.692-1.684-.005.007-.269.375-.214 1.42.019.36.162.897.341 1.214V4.463h.75V7.06c.18-.297.318-.799.337-1.164.055-1.042-.194-1.481-.2-1.49Zm-1.32.02c-.01.006-.704.387-.704 1.433 0 1.055.366 1.512.366 1.512s-.882-.586-.882-1.474c0-.884 1.205-1.464 1.22-1.471Zm1.68 0c.02.01 1.22.54 1.22 1.422-.001.888-.882 1.523-.882 1.523s.367-.457.367-1.512c0-1.043-.69-1.425-.705-1.433Zm-.454-.15s-.24.113-.453.113a1 1 0 0 1-.418-.113v-.15c.008.004.217.112.432.112.219 0 .44-.112.44-.112v.15Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
